import { render } from "./addpurchase.vue?vue&type=template&id=5cec6516"
import script from "./addpurchase.vue?vue&type=script&lang=js"
export * from "./addpurchase.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__